// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"02d60891","337":"0005408f"}[chunkId] + ".chunk.js";
};